import { type FC } from "react";

import { useQuery } from "@apollo/client/react";

import { faAnglesUpDown } from "@fortawesome/pro-duotone-svg-icons/faAnglesUpDown";
import { faPowerOff } from "@fortawesome/pro-duotone-svg-icons/faPowerOff";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { MenuButton } from "@headlessui/react";

import { MeDocument } from "@app_schema";

import { Menu } from "@styled/menu";
import { MenuItemLink } from "@styled/menu_item_link";
import { MenuItems } from "@styled/menu_items";
import { MenuSeparator } from "@styled/menu_separator";
import { Skeleton } from "@styled/skeleton";

import { MenuProfileAvatar } from "./menu_profile_avatar";
import { MenuProfileGroup } from "./menu_profile_group";
import { MenuProfileName } from "./menu_profile_name";
import { MenuProfileOrganizations } from "./menu_profile_organizations";

export const MenuProfile: FC = () => {
  const { data } = useQuery(MeDocument);
  const me = data?.me;

  return (
    <Menu>
      <MenuButton className="hover:bg-quiet-hover w-full cursor-pointer rounded-md px-2 py-2 font-semibold text-slate-800 transition">
        <div className="flex items-center gap-1.5">
          <div className="shrink-0 grow-0">
            <MenuProfileAvatar me={me} />
          </div>
          <div className="min-w-0 shrink grow truncate text-left">
            {me ? (
              <>
                <MenuProfileName me={me} />
                <MenuProfileGroup me={me} />
              </>
            ) : (
              <Skeleton className="h-4 w-full rounded bg-slate-200" />
            )}
          </div>
          <div className="shrink-0 grow-0">
            <FontAwesomeIcon
              icon={faAnglesUpDown}
              className="text-xs text-slate-400"
            />
          </div>
        </div>
      </MenuButton>

      <MenuItems anchor="bottom start" className="z-50 w-64">
        {me && <MenuProfileOrganizations me={me} />}
        <MenuSeparator />
        <MenuItemLink to="/logout">
          <FontAwesomeIcon icon={faPowerOff} /> Logout
        </MenuItemLink>
      </MenuItems>
    </Menu>
  );
};
